import { HalfFloatType } from 'three'
import { BlendFunction, ToneMappingMode } from 'postprocessing'
import {
  EffectComposer,
  Bloom,
  ToneMapping,
  Vignette,
  SMAA,
  FXAA,
} from '@react-three/postprocessing'
import { usePostProcessingStore } from '../stores/usePostProcessingStore'
import { useFpsMonitor } from '../hooks/useFpsMonitor'
import { useShallow } from 'zustand/react/shallow'

export default function PostProcessingStack() {
  useFpsMonitor()

  const { globalEnabled, aaMode } = usePostProcessingStore(
    useShallow((s) => ({ globalEnabled: s.globalEnabled, aaMode: s.aaMode }))
  )

  const bloom = usePostProcessingStore(
    useShallow((s) => ({
      enabled: s.bloomEnabled,
      intensity: s.bloomIntensity,
      threshold: s.bloomLuminanceThreshold,
      smoothing: s.bloomLuminanceSmoothing,
    }))
  )

  const vignette = usePostProcessingStore(
    useShallow((s) => ({
      enabled: s.vignetteEnabled,
      darkness: s.vignetteDarkness,
      offset: s.vignetteOffset,
    }))
  )

  const toneMapping = usePostProcessingStore(
    useShallow((s) => ({
      enabled: s.toneMappingEnabled,
      mode: s.toneMappingMode,
    }))
  )

  return (
    <EffectComposer multisampling={0} frameBufferType={HalfFloatType} enabled={globalEnabled}>
      {aaMode === 'smaa' ? <SMAA /> : aaMode === 'fxaa' ? <FXAA /> : <></>}
      <Bloom
        blendFunction={bloom.enabled ? BlendFunction.SCREEN : BlendFunction.SKIP}
        intensity={bloom.intensity}
        luminanceThreshold={bloom.threshold}
        luminanceSmoothing={bloom.smoothing}
      />
      <Vignette
        blendFunction={vignette.enabled ? BlendFunction.NORMAL : BlendFunction.SKIP}
        darkness={vignette.darkness}
        offset={vignette.offset}
      />
      <ToneMapping
        blendFunction={toneMapping.enabled ? BlendFunction.NORMAL : BlendFunction.SKIP}
        mode={toneMapping.mode as ToneMappingMode}
      />
    </EffectComposer>
  )
}
